define.alias("shared/components/shared/color-picker/header", "calendar/components/shared/color-picker/header");